import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { IInstitutionState } from "./types";
import { IIDAStore } from "../types";
import { Institution } from "../../models/institution-model";
import { institutionService } from "../../services/institution.service";
import { getDay } from "date-fns";
import { dayInWeek } from "../../utils/dateUtils";

export const getInitialState = (): IInstitutionState => {
  return {
    institutions: [],
    Loaded: false
  };
};

const namespaced = true;

export const getters: GetterTree<IInstitutionState, IIDAStore> = {
  getInstitution: (state) => {
    return state.institutions[0];
  },
  institutions: (state) => () => {
    return state.institutions;
  },
  getSalerySystem: (state) => () => {
    return state.institutions[0].salary_system;
  },
  openCloseTimeDate:
    (state) =>
      (date: Date): { open: number; close: number } => {
        const daynum = getDay(date);
        const inst = state.institutions[0];
        if (!inst) {
          return { open: 0, close: 0 };
        }
        switch (daynum) {
          case dayInWeek.MONDAY:
            return { open: inst.opentime_monday, close: inst.closetime_monday };

          case dayInWeek.TUESDAY:
            return { open: inst.opentime_tuesday, close: inst.closetime_tuesday };

          case dayInWeek.WEDNESDAY:
            return {
              open: inst.opentime_wednesday,
              close: inst.closetime_wednesday
            };

          case dayInWeek.THURSDAY:
            return {
              open: inst.opentime_thursday,
              close: inst.closetime_thursday
            };

          case dayInWeek.FRIDAY:
            return { open: inst.opentime_friday, close: inst.closetime_friday };

          case dayInWeek.SATURDAYS:
            return {
              open: inst.opentime_saturday,
              close: inst.closetime_saturday
            };

          case dayInWeek.SUNDAY:
            return { open: inst.opentime_sunday, close: inst.closetime_sunday };

          default:
            return { open: 0, close: 0 };
        }
      }
};

export const actions: ActionTree<IInstitutionState, IIDAStore> = {
  reset({ commit }): void {
    commit("reset");
  },
  fetchInstitutions(
    { commit, state },
    query: { institutionId: number; forceUpdate: boolean }
  ): Promise<Institution[]> {
    return new Promise((resolve, reject) => {
      try {
        if (state.Loaded && !query.forceUpdate) {
          resolve(state.institutions);
        } else {
          institutionService
            .fetchInstitution(query.institutionId)
            .then((institutions: Institution[]) => {
              commit("updateInstitutions", institutions);
              return resolve(institutions);
            });
        }
      } catch (error) {
        return reject(error);
      }
    });
  },
  async fetchInstitutionTypes(): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        institutionService
          .fetchInstitutionTypes()
          .then((institutionTypes: any) => {
            resolve(institutionTypes);
          });
      } catch (error) {
        return reject(error);
      }
    });
  },
  async fetchInstitutionTypesById(
    none,
    institutionTypeId: number
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        institutionService
          .fetchInstitutionTypeById(institutionTypeId)
          .then((institutionType: any) => {
            resolve(institutionType);
          });
      } catch (error) {
        return reject(error);
      }
    });
  },
  async updateInstitution({ commit }, institution: Institution): Promise<any> {
    return new Promise((resolve, reject) => {
      institutionService
        .updateInstitution(institution)
        .then((institution: any) => {
          commit("updateInstitutions", [institution]);
          resolve(institution);
          commit("updateInstitution", institution);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async fetchPostalDistricts(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      try {
        institutionService
          .fetchPostalDistricts()
          .then((postalDistricts: any[]) => {
            resolve(postalDistricts);
          });
      } catch (error) {
        return reject(error);
      }
    });
  }
};

export const mutations: MutationTree<IInstitutionState> = {
  reset(state: IInstitutionState): void {
    Object.assign(state, getInitialState());
  },
  updateInstitutions(
    state: IInstitutionState,
    institutions: Institution[]
  ): void {
    state.institutions = [
      ...state.institutions.filter(
        (newInstitution: Institution) =>
          !institutions.find((existing: Institution) => {
            return existing.equals(newInstitution);
          })
      ),
      ...institutions
    ];
    state.Loaded = true;
  },
  updateInstitution(state: IInstitutionState, institution: Institution): void {
    const index = state.institutions.findIndex((a) => a.id === institution.id);
    state.institutions.splice(index, 1);
    state.institutions.push(institution);
  }
};

export const institutionStoreModule: Module<IInstitutionState, IIDAStore> = {
  namespaced: namespaced,
  state: getInitialState(),
  getters: getters,
  actions: actions,
  mutations: mutations
};
